export default [{
  name: 'categoriesList',
  subpath: 'categories'
}, {
  name: 'commentsList',
  subpath: 'comments'
}, {
  name: 'domainsList',
  subpath: 'domains'
}, {
  name: 'embedsList',
  subpath: 'embeds'
}, {
  name: 'followsList',
  subpath: 'follows'
}, {
  name: 'mediaList',
  subpath: 'media'
}, {
  name: 'pageTemplates',
  subpath: 'page-templates'
}, {
  name: 'pluginsList',
  subpath: 'plugins'
}, {
  name: 'postsList',
  subpath: 'posts'
}, {
  name: 'postTypesList',
  subpath: 'post-types'
}, {
  name: 'shortcodesList',
  subpath: 'shortcodes'
}, {
  name: 'stats',
  subpath: 'stats'
}, {
  name: 'statsClicks',
  subpath: 'stats/clicks'
}, {
  name: 'statsCommentFollowers',
  subpath: 'stats/comment-followers'
}, {
  name: 'statsComments',
  subpath: 'stats/comments'
}, {
  name: 'statsCountryViews',
  subpath: 'stats/country-views'
}, {
  name: 'statsFollowers',
  subpath: 'stats/followers'
}, {
  name: 'statsInsights',
  subpath: 'stats/insights'
}, {
  name: 'statsPublicize',
  subpath: 'stats/publicize'
}, {
  name: 'statsReferrers',
  subpath: 'stats/referrers'
}, {
  name: 'statsSearchTerms',
  subpath: 'stats/search-terms'
}, {
  name: 'statsStreak',
  subpath: 'stats/streak'
}, {
  name: 'statsSummary',
  subpath: 'stats/summary'
}, {
  name: 'statsTags',
  subpath: 'stats/tags'
}, {
  name: 'statsTopAuthors',
  subpath: 'stats/top-authors'
}, {
  name: 'statsTopPosts',
  subpath: 'stats/top-posts'
}, {
  name: 'statsArchives',
  subpath: 'stats/archives'
}, {
  name: 'statsVideoPlays',
  subpath: 'stats/video-plays'
}, {
  name: 'statsVisits',
  subpath: 'stats/visits'
}, {
  name: 'tagsList',
  subpath: 'tags'
}, {
  name: 'usersList',
  subpath: 'users'
}, {
  name: 'wpcomPluginsList',
  subpath: 'wpcom-plugins'
}];